import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initRealWeddingFunctions() {
    document.querySelectorAll('.js-stepSlider').forEach(function (sliderEl) {
        const footerEl = sliderEl.nextElementSibling;
        if (!footerEl || !footerEl.classList.contains('stepSlider__footer')) return;

        const paginationEl = footerEl.querySelector('.stepSlider__pagination');
        const navPrev     = footerEl.querySelector('.stepSlider__nav--prev');
        const navNext     = footerEl.querySelector('.stepSlider__nav--next');

        function buildBullets(swiperInstance) {
            paginationEl.innerHTML = '';
            const count = swiperInstance.snapGrid.length;
            for (let i = 0; i < count; i++) {
                const bullet = document.createElement('span');
                bullet.className = 'swiper-pagination-bullet' + (i === swiperInstance.snapIndex ? ' swiper-pagination-bullet-active' : '');
                bullet.addEventListener('click', () => swiperInstance.slideTo(i));
                paginationEl.appendChild(bullet);
            }
        }

        function updateBullets(swiperInstance) {
            paginationEl.querySelectorAll('.swiper-pagination-bullet').forEach((b, i) => {
                b.classList.toggle('swiper-pagination-bullet-active', i === swiperInstance.snapIndex);
            });
        }

        const isPlan = sliderEl.classList.contains('js-stepSlider--plan');

        const options = isPlan
            ? {
                spaceBetween: 30,
                slidesPerView: 1,
                slidesPerGroup: 1,
                breakpoints: {
                    769: { slidesPerView: 2 },
                    1000: { slidesPerView: 3 },
                    1200: { slidesPerView: 3.3 },
                },
              }
            : {
                spaceBetween: 30,
                slidesPerView: 1.1,
                slidesPerGroup: 1,
                breakpoints: {
                    769: { slidesPerView: 2 },
                    1000: { slidesPerView: 3 },
                    1200: { slidesPerView: 2.52 },
                },
              };

        new Swiper(sliderEl, Object.assign(options, {
            navigation: {
                prevEl: navPrev,
                nextEl: navNext,
            },
            on: {
                init: function () {
                    buildBullets(this);
                },
                breakpoint: function () {
                    buildBullets(this);
                },
                slideChange: function () {
                    updateBullets(this);
                },
            },
        }));
    });
}